import React from 'react';
import { TicketBatchContainer } from '../containers/TicketBatchContainer';

export const HomePage = ({ event, onNavigate }) => {
  // Se não tiver evento (modo antigo), usa CONFIG
  const eventData = event || {
    eventName: "Evento PD Castelo",
    imageUrl: null,
    cards: [],
    subtitle: "",
    intro: ""
  };

  // Debug dos cards

  return (
    <div className="min-h-screen flex flex-col items-center p-4 font-body">
      <h1 className="text-5xl md:text-6xl font-display text-primary my-4 text-center">
        {eventData.eventName}
      </h1>
      
      {eventData.subtitle && (
        <p className="text-xl text-center text-gray-600 mb-4 max-w-3xl">
          {eventData.subtitle}
        </p>
      )}

      <div className="bg-white rounded-lg p-6 shadow-lg max-w-3xl w-full mx-auto transition-all duration-300 border-2 border-primary overflow-hidden hover:-translate-y-1 hover:shadow-xl">
        
        {/* Imagem do evento */}
        {(eventData.imageUrl || eventData.imageId) && (
          <div className="relative -mx-6 -mt-6 mb-6 overflow-hidden bg-gray-100">
            <img 
              src={eventData.imageId 
                ? `https://drive.google.com/thumbnail?id=${eventData.imageId}&sz=w1000`
                : (eventData.thumbnailUrl || eventData.imageUrl)
              }
              alt={eventData.eventName}
              className="w-full h-auto object-cover"
              style={{ maxHeight: '400px' }}
              onError={(e) => {
                // Tenta URLs alternativas
                if (eventData.imageId && e.target.src.includes('thumbnail')) {
                  e.target.src = `https://drive.google.com/uc?export=view&id=${eventData.imageId}`;
                } else if (eventData.imageId && e.target.src.includes('uc?export=view')) {
                  e.target.src = `https://lh3.googleusercontent.com/d/${eventData.imageId}`;
                } else {
                  // Esconde a imagem se todas as tentativas falharem
                  e.target.parentElement.style.display = 'none';
                }
              }}
            />
          </div>
        )}

        {/* Intro */}
        {eventData.intro && (
          <p className="text-center text-gray-700 mb-6">
            {eventData.intro}
          </p>
        )}

        {/* Cards */}
        {eventData.cards && eventData.cards.length > 0 && eventData.cards.map((card, index) => (
          <div 
            key={index} 
            className="rounded-lg p-4 border mb-4"
            style={{
              backgroundColor: getCardBackgroundColor(card.cardColor),
              borderColor: getCardBorderColor(card.cardColor)
            }}
          >
            <h2 className="text-lg font-display text-primary mb-2">
              {card.cardTitle}
            </h2>
            <ul className="list-disc list-inside text-gray-700 space-y-1">
              {card.items && card.items.map((item, idx) => (
                <li key={idx}>{item}</li>
              ))}
            </ul>
          </div>
        ))}
     
      <div className="mb-6">
        <TicketBatchContainer event={event} />
      </div>

      </div>

      <button 
        onClick={() => onNavigate('selecao')}
        className="w-full max-w-md mx-auto mt-4 px-8 py-4 text-xl font-display text-white rounded-full bg-gradient-to-r from-primary to-primary-hover hover:from-primary-hover hover:to-[#007538] transition-all duration-300 uppercase shadow-md flex items-center justify-center gap-3"
      >
        Comprar Ingressos
      </button>
      
      <button 
        onClick={() => onNavigate('editOrder')}
        className="w-full max-w-md mx-auto mt-4 px-8 py-4 text-xl font-display text-white rounded-full bg-gradient-to-r from-primary to-primary-hover hover:from-primary-hover hover:to-[#007538] transition-all duration-300 uppercase shadow-md flex items-center justify-center gap-3"
      >
        Editar Pedido
      </button>
      
      {/* Botão voltar para lista de eventos */}
      {event && (
        <button 
          onClick={() => window.location.href = '/'}
          className="mt-6 text-gray-600 hover:text-gray-800 underline"
        >
          ← Ver todos os eventos
        </button>
      )}
    </div>
  );
};

// Funções auxiliares para cores dos cards
function getCardBackgroundColor(color) {
  const colors = {
    blue: '#eff6ff',
    green: '#f0fdf4',
    red: '#fef2f2',
    yellow: '#fefce8',
    purple: '#faf5ff',
    pink: '#fdf2f8',
    orange: '#fff7ed',
    gray: '#f9fafb'
  };
  return colors[color?.toLowerCase()] || '#f9fafb';
}

function getCardBorderColor(color) {
  const colors = {
    blue: '#bfdbfe',
    green: '#bbf7d0',
    red: '#fecaca',
    yellow: '#fde047',
    purple: '#e9d5ff',
    pink: '#fbcfe8',
    orange: '#fed7aa',
    gray: '#e5e7eb'
  };
  return colors[color?.toLowerCase()] || '#e5e7eb';
}